module.exports = __webpack_public_path__ + "media/images/flavours/icon-lactique_dark-db383abf21558d5efc34944d7cf6c84b.png";